export default __webpack_public_path__ + "static/media/new-bg1.56f8c0fa.jpg";